import Icon from "@react-native-vector-icons/material-design-icons";
import theme from "assets/theme";
import React from "react";
import { Pressable, StyleSheet, TextInput, View } from "react-native";

const classes = StyleSheet.create({
  root: {
    flex: 1,
    width: "100%",
    margin: 10,
    padding: 10,
    gap: 10,
    backgroundColor: theme.color.grey,
    borderRadius: 6,
    color: theme.color.darkGrey,
    flexDirection: "row",
    alignContent: "center",
    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.2)",
  },
  iconContainer: {
    justifyContent: "center",
  },
  searchInput: {
    flexBasis: "100%",
    color: theme.color.darkGrey,
    outlineStyle: "none",
  },
});

export default function SearchBar(props) {
  const {
    placeholder = "Search...",
    value,
    onChangeText,
    style: styleProp = {},
  } = props;

  return (
    <View style={[classes.root, styleProp]}>
      <View style={classes.iconContainer}>
        <Icon name="magnify" size={22} color={theme.color.backgroundText} />
      </View>
      <TextInput
        value={value}
        placeholder={placeholder}
        onChangeText={onChangeText}
        style={classes.searchInput}
      />
      {!!value?.length && (
        <Pressable
          onPress={() => onChangeText("")}
          style={classes.iconContainer}
        >
          <Icon name="close" size={22} color={theme.color.backgroundText} />
        </Pressable>
      )}
    </View>
  );
}
